
import { ArticleCard } from "@/components/ArticleCard";
import { Article } from "@/types/article";

interface ArticleGridProps {
  articles: Article[] | undefined;
  isLoading: boolean;
  searchQuery: string;
  selectedCategory: string | null;
  showMax?: number;
}

export const ArticleGrid = ({ articles, isLoading, searchQuery, selectedCategory, showMax }: ArticleGridProps) => {
  const filteredArticles = articles?.filter((article) => {
    const matchesCategory = selectedCategory ? article.category === selectedCategory : true;
    const matchesSearch = searchQuery
      ? article.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
        article.content.toLowerCase().includes(searchQuery.toLowerCase()) ||
        article.excerpt.toLowerCase().includes(searchQuery.toLowerCase())
      : true;
    return matchesCategory && matchesSearch;
  });

  // Apply showMax limit if specified
  const displayArticles = showMax ? filteredArticles?.slice(0, showMax) : filteredArticles;

  if (isLoading) {
    return (
      <div className="grid grid-cols-1 gap-6">
        {[1, 2, 3].map((i) => (
          <div
            key={i}
            className="h-96 bg-foreground/5 rounded-lg animate-pulse"
          />
        ))}
      </div>
    );
  }

  if (displayArticles?.length === 0) {
    return (
      <div className="text-center py-12">
        <p className="text-muted-foreground">
          {searchQuery
            ? "検索条件に一致する記事が見つかりませんでした。"
            : selectedCategory
            ? `${selectedCategory}の記事はまだありません。`
            : "記事がまだありません。"}
        </p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
      {displayArticles?.map((article) => (
        <ArticleCard
          key={article.id}
          id={article.id}
          title={article.title}
          category={article.category}
          excerpt={article.excerpt}
          imageUrl={article.image_url || undefined}
          sub_category={article.sub_category}
          location={article.location}
          eventDate={article.event_date}
          writer={article.writer}
        />
      ))}
    </div>
  );
};
